// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-line {
  width: 100%;
  height: 14px;
  border-radius: 8px;
  background: linear-gradient(90deg, #e7ebf0 25%, #f3f6f9 50%, #e7ebf0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.1s ease-in-out infinite;
}

.skeleton-stack {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.skeleton-text {
  font-size: 13px;
  color: #6b7280;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/skeleton.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".skeleton-line {\n  width: 100%;\n  height: 14px;\n  border-radius: 8px;\n  background: linear-gradient(90deg, #e7ebf0 25%, #f3f6f9 50%, #e7ebf0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.1s ease-in-out infinite;\n}\n\n.skeleton-stack {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.skeleton-text {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
